import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@material';
import { AutocompleteWithControlsModule } from '@shared/modules/autocomplete-with-controls';
import { AutocompleteModule } from '@autocomplete';
import { PipeModule } from '@pipes/pipes.module';
import { DirectivesModule } from '@core/directives/directives.module';
import { AddressNoteComponent } from './address-note/address-note.component';
import { BuildingComponent } from './building/building.component';
import { CitySelectComponent } from './city-select/city-select.component';
import { PostboxSelectComponent } from './postbox-select/postbox-select.component';
import { RoomComponent } from './room/room.component';
import { StreetSelectComponent } from './street-select/street-select.component';
import { WarehouseSelectComponent } from './warehouse-select/warehouse-select.component';
import { StoreSelectComponent } from './warehouse-select/store-select/store-select.component';

@NgModule({
  declarations: [
    AddressNoteComponent,
    BuildingComponent,
    CitySelectComponent,
    PostboxSelectComponent,
    RoomComponent,
    StreetSelectComponent,
    WarehouseSelectComponent,
    StoreSelectComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    PipeModule,
    DirectivesModule,
    AutocompleteModule,
    AutocompleteWithControlsModule,
  ],
  exports: [
    AddressNoteComponent,
    BuildingComponent,
    CitySelectComponent,
    PostboxSelectComponent,
    RoomComponent,
    StreetSelectComponent,
    WarehouseSelectComponent,
    StoreSelectComponent,
  ],
})
export class AddressComponentsModule {}
